<deprecated-labeled-field
  [label]="label"
  [help]="help"
  [required]="required"
  [labelDirection]="labelDirection"
  [actionText]="actionText"
  (action)="action.emit($event)"
>
  <range-slider
    [lowerMin]="lowerMin"
    [lowerMax]="lowerMax"
    [upperMin]="upperMin"
    [upperMax]="upperMax"
    [type]="type"
    [dragSignificantDigits]="dragSignificantDigits"
    [value]="value"
    (valueChange)="valueChange.emit($event)"
  ></range-slider>
</deprecated-labeled-field>
